<template>
  <div>
    <filtro-cadu v-model="valueData" :items="items" @limparFiltro="limparFiltro" @filtrar="selectArea">
      <div slot="body" style="height: 420px;">
        <v-row class="mx-2">
          <v-col cols="auto"> <div class="fontColor1--text">FILTRAR ÁREAS</div> </v-col>
        </v-row>

        <ValidationObserver ref="observer">
          <v-row class="mx-2">
            <v-col cols="12">
              <checkList-cadu
                ref="refCheckList"
                titulo="Buscar por área"
                itemTextFiltro="nome"
                :lengthSize="20"
                :listaFiltro="listaAreas"
                :tasks="areasSelecionadas"
                overflow
              />
            </v-col>

            <v-col cols="12">
              <validation-provider name="nome" mode="eager" rules="max:100" v-slot="{ errors }">
                <input-cadu
                  :errorMessage="errors[0]"
                  title="Nome do responsável"
                  onlyText
                  :max="'100'"
                  v-model="nomeData"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </ValidationObserver>
      </div>
    </filtro-cadu>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import Areas from '@/services/Areas/Areas'

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },

  props: {
    value: {
      type: Boolean,
      required: false
    },
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      valueData: this.value,
      nomeData: '',
      listaAreas: [],
      areasSelecionadas: [],
      id: []
    }
  },

  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    this.getItensAreas()
  },

  methods: {
    async getItensAreas() {
      const idUnimed = localStorage.getItem('idUnimed')

      const areas = new Areas(this.tokenBearer, this.$appConfig.config.API, idUnimed)

      await areas
        .getItens()
        .then(({ data }) => (this.listaAreas = data.map((item) => item.tipoArea)))
        .catch(() => this.$router.push('/erro'))
    },

    selectArea() {
      this.$emit('filtro', { nome: this.nomeData, id: this.id })
    },
    limparFiltro() {
      this.nomeData = ''
      this.id = []

      this.areasSelecionadas = []
    }
  },

  watch: {
    value() {
      this.valueData = this.value
    },
    valueData() {
      if (!this.valueData) {
        this.$emit('input', false)
      }
    },
    areasSelecionadas(areas) {
      this.id = areas.map((it) => it.id)
    }
  }
}
</script>
